import CustomErrorMessage from './CustomErrorMessage';

export default function Page400() {
  return (
    <CustomErrorMessage
      code={400}
      title="This link isn't complete"
      body="Part of the address is missing or wrong. Open the link again from the original message or QR code."
    />
  );
}
